import { App } from '@capacitor/app';

export default {
  async created() {
    const result = await App.addListener('appStateChange', async (state) => {
      this.$log.info(`App state changed. Is active? ${state.isActive}`);
      if (state.isActive) {
        await this.$store.dispatch('auth/REFRESH_auth');
      }
      this.$root.$emit('App.appStateChange', state.isActive);
    });
    this.$log.info(result);
  },
};
